module.exports = __webpack_public_path__ + "img/solution_1.531f5951.png";